/**
 * External dependencies
 */
import {
	createResponsiveStyles,
} from '~cartzillagb/util'
import deepmerge from 'deepmerge'

/**
 * Internal dependencies
 */
import { showOptions } from './util'

export const createStyles = props => {
	// const getValue = __getValue( props.attributes )

	const show = showOptions( props )

	const styles = []

	// Spacing.
	if ( show.headerSpacing ) {
		styles.push( ...createResponsiveStyles( '.czgb-products-with-header__header', 'header%sBottomMargin', 'marginBottom', '%spx', props.attributes, true ) )
	}

	if ( show.titleSpacing ) {
		styles.push( ...createResponsiveStyles( '.czgb-products-with-header__title', 'header%sBottomMargin', 'marginBottom', '%spx', props.attributes, true ) )
	}

	if ( show.footerSpacing ) {
		styles.push( ...createResponsiveStyles( '.czgb-products-with-header__footer', 'footer%sTopMargin', 'marginTop', '%spx', props.attributes, true ) )
	}

	return deepmerge.all( styles )
}

export default createStyles
